/**
 *
 * @param date {Date | number}
 * @param options {Intl.DateTimeFormatOptions}
 * @param localization {string}
 * @returns {string}
 */
export default (date, options = { timeZone: 'utc' }, localization = 'es-VE') => new Intl.DateTimeFormat(localization, options)
  .format(date instanceof Date ? date : new Date(date))